var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudiologo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 479.6",
    style: {
      enableBackground: "new 0 0 500 479.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EB7500;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB7500",
    className: "st0",
    d: "M106.6,55.9C118.7,18,167,4.3,198.9,28.5l16.5,14.8L39.5,272.1L106.6,55.9z M2.2,392.2l37.4-119.1L225.3,50.7 l49.4,42.2L6.5,422.8l277-322.6l47.3,41.1L73.6,460.7C30.7,473.4-9.9,434.4,2.2,392.2z M462.6,369L79.1,460.7c-2.2,1-3.3,1-5.5,1 l264.9-311l48.4,42.2L202.2,427l193.4-226.6l83.5,73.8C512.1,302.6,505.5,354.3,462.6,369z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudiologo);
export default __webpack_public_path__ + "static/media/studiologo.0e177bde422bbcb5e523ef21c974a042.svg";
export { ForwardRef as ReactComponent };